
import { Injectable } from "@angular/core";

import { MapperMetaDatiProtocolloGescor } from "./mapper-metadati-protocollo-gescor";
import { MapperInterface } from "../mapper-inteface";
import { MetadatiCorrispondenzaArrivoDTO } from "@app/shared/dto/gescor/metadati-corrispondenza-arrivoDTO";
import { MetadatiCorrispondenzaArrivoVO } from "@app/shared/vo/gescor/metadati-corrispondenza-arrivoVO";

@Injectable({
  providedIn: "root"
})
export class MapperMetaDatiCorrispondenza
  implements
    MapperInterface<
      MetadatiCorrispondenzaArrivoDTO,
      MetadatiCorrispondenzaArrivoVO
    > {
  constructor(
    private mapperMetadatiProtocollo: MapperMetaDatiProtocolloGescor //   private mapperRecapito: MapperRecapito
  ) {}
  convertVoToDto(
    e: MetadatiCorrispondenzaArrivoVO
  ): MetadatiCorrispondenzaArrivoDTO {
    throw new Error("Method not implemented.");
  }
  convertDtoToVo(
    t: MetadatiCorrispondenzaArrivoDTO
  ): MetadatiCorrispondenzaArrivoVO {
    /* console.log(
      "[MapperMetaDatiCorrispondenza] MetadatiCorrispondenzaArrivoDTO => MetadatiCorrispondenzaArrivoVO",
      t
    ); */
    const metadatiCorrispondenzaArrivoVO = new MetadatiCorrispondenzaArrivoVO();
    metadatiCorrispondenzaArrivoVO.dataRicezione = t.dataRicezione;
    metadatiCorrispondenzaArrivoVO.metadatiProtocollo = this.mapperMetadatiProtocollo.convertDtoToVo(
      t.metadatiProtocollo
    );
    /*   metadatiCorrispondenzaArrivoVO.mittente = this.mapperRecapito.convertDtoToVo(
      t.mittente
    ); */
    metadatiCorrispondenzaArrivoVO.oggetto = t.oggetto;
    metadatiCorrispondenzaArrivoVO.riservata = t.riservata;

    return (
      metadatiCorrispondenzaArrivoVO || new MetadatiCorrispondenzaArrivoVO()
    );
  }
  convertListVoToDto(
    e: MetadatiCorrispondenzaArrivoVO[]
  ): MetadatiCorrispondenzaArrivoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: MetadatiCorrispondenzaArrivoDTO[]
  ): MetadatiCorrispondenzaArrivoVO[] {
    throw new Error("Method not implemented.");
  }
}
